import { RENDER_PHASE } from '../_universal';
import analytics from './analytics';
import hotjar from './hotjar';
import newrelic from './newrelic';
import { getAppInsights } from '../shared/components/ApplicationInsights';

export default function createUniversalContext(options) {
  const { history } = options;
  const appInsights = getAppInsights();

  const context = {
    renderPhase: options.renderPhase || RENDER_PHASE.CLIENT_RENDER,

    status() {
      // does nothing on client
    },

    redirect(code, path, redirectOptions) {
      if (typeof path === 'undefined') {
        path = code;
      }
      if (redirectOptions && redirectOptions.fullNavigation) {
        if (typeof global.location !== 'undefined') {
          global.location.href = path;
        }
        return;
      }
      if (history) {
        history.push(path);
      }
    },

    trackPage(trackOptions = {}) {
      if (trackOptions.onClient === false) {
        return;
      }
      analytics.trackPage(trackOptions);
    },

    trackEvent(trackOptions = {}) {
      if (trackOptions.onClient === false) {
        return;
      }
      analytics.trackEvent(trackOptions);
      newrelic.trackEvent(trackOptions);
      hotjar.trackEvent(trackOptions);
      if (appInsights) {
        appInsights.trackEvent({
          name: trackOptions.event,
          properties: trackOptions.properties,
        });
      }
    },

    trackError(trackOptions = {}) {
      analytics.trackError(trackOptions);
      newrelic.trackError(trackOptions);
      // eslint-disable-next-line no-console
      console.error(trackOptions.error);
    },
  };

  if (history && options.trackRouterChanges !== false) {
    history.listen((state) => {
      if (state.action === 'PUSH') {
        context.trackPage();
      }
    });
  }
  if (options.skipPageCall !== true) {
    context.trackPage();
  }

  return context;
}
